import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UnitConfigurationService {
  readonly unitOfMeasureSystem = signal<'I' | 'M'>('M');
  readonly unitConfig: Record<string, { I: string; M: string }> = {
    weight: {
      I: 'lb',
      M: 'kg',
    },
    length: {
      I: 'in',
      M: 'cm',
    },
    height: {
      I: 'in',
      M: 'cm',
    },
    width: {
      I: 'in',
      M: 'cm',
    },
    dimension: {
      I: 'in',
      M: 'cm',
    },
  };

  getUnitMappingByType(activeUnit: 'I' | 'M') {
    return Object.keys(this.unitConfig).reduce(
      (acc, key) => {
        acc[key] = this.unitConfig[key][activeUnit];
        return acc;
      },
      {} as Record<string, string>,
    );
  }
}
